import { Injectable, inject } from '@angular/core';
import { AdminPaymentApiService } from '../api/services/admin-payment-api.service';
import { CollectionRequestBuilder } from '@web/common';
import { isNil, Nillable } from '@web/utils';
import { catchError, map, Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { AdminPaymentMethodCollectionItemResponse } from '../api/responses/admin-payment-method-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class AdminPaymentMethodSelectItemsProviderService {
  private readonly paymentApi = inject(AdminPaymentApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  public fetchSelectItems<
    Key extends keyof AdminPaymentMethodCollectionItemResponse,
  >(
    key: Key,
    query: Nillable<string> = null,
  ): Observable<SelectItem<AdminPaymentMethodCollectionItemResponse[Key]>[]> {
    return this.paymentApi
      .fetchCollection({
        request: this.collectionRequestBuilder.disablePagination().build(),
        skipByLoading: true,
        cacheable: true,
      })
      .pipe(
        map((response) =>
          response.items
            .filter((item) => {
              if (isNil(query)) {
                return item;
              }

              return item.name.toLowerCase().includes(query);
            })
            .map((item) => new SelectItem(item.name, item[key])),
        ),
        catchError(() => of([])),
      );
  }
}
